import Loadable from 'react-loadable';

const CreateKudosEmbed = Loadable<any, any>({
  loader: () => import(/* webpackChunkName: "CreateKudosPage" */ './CreateKudosEmbed'),
  loading: () => null,
});

export default CreateKudosEmbed;
